module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "coverimg",
    class: {
      'hasvideo': _vm.topVideo.length > 2
    }
  }, [(!_vm.topVideoUrl) ? _c('img', {
    staticClass: "responsiveimg",
    attrs: {
      "src": _vm.topImageUrl,
      "alt": "B2B IMAGE",
      "title": "TONE B2B"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.topVideoUrl) ? _c('video', {
    staticClass: "responsiveimg",
    attrs: {
      "autoplay": "",
      "loop": "",
      "muted": ""
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.topVideoUrl,
      "type": "video/mp4",
      "poster": _vm.topImageUrl
    }
  })]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa fa-play-circle",
    on: {
      "click": function($event) {
        return _vm.openVideoModal('', 'Top')
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "watchvideolink",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.openVideoModal('', 'Top')
      }
    }
  }, [_vm._v("Watch Video")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('h1', [_vm._v(_vm._s(_vm.topHeading))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.topParaLine1))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-rounded btn-primary btn-lg",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important',
      'outline': 'none'
    }),
    on: {
      "click": function($event) {
        return _vm.scrollToFormSection()
      }
    }
  }, [_vm._v("Get Started")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container showmobile"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', [_vm._v(_vm._s(_vm.topHeading))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.topParaLine1))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-rounded btn-primary btn-lg",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important',
      'outline': 'none'
    }),
    on: {
      "click": function($event) {
        return _vm.scrollToFormSection()
      }
    }
  }, [_vm._v("Get Started")])])])]), _vm._v(" "), _c('div', {
    staticClass: "pannelsection"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h2', [_vm._v(_vm._s(_vm.panelsHeading))])])])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.b2bVideos) ? _c('div', {
    staticClass: "Videoscarosal"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v(_vm._s(_vm.videosHeading))]), _vm._v(" "), _c('div', {
    staticClass: "slider responsive-slick-display-videos"
  }, _vm._l((_vm.b2bVideos), function(video) {
    return _c('div', {
      staticClass: "slide-player"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": video.image,
        "alt": video.description,
        "title": video.title
      },
      on: {
        "click": function($event) {
          return _vm.openVideoModal(video, 'Regular')
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor",
      on: {
        "click": function($event) {
          return _vm.openVideoModal(video, 'Regular')
        }
      }
    }, [_vm._v("\n                            " + _vm._s(video.title) + "\n                            "), _c('small', [_vm._v(_vm._s(video.description))])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pannelsection"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "benefit-panel benefit-panel-bg"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "bottom-row"
  }, [_c('div', {
    staticClass: "metric"
  }, [_c('div', {
    staticClass: "donut",
    style: (_vm.donut1value)
  }, [_c('span', [_vm._v("82%")])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "metric"
  }, [_c('div', {
    staticClass: "donut",
    style: (_vm.donut2value)
  }, [_c('span', [_vm._v("50%")])]), _vm._v(" "), _vm._m(4)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "logoscarosal"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v(_vm._s(_vm.logosHeading))]), _vm._v(" "), _c('div', {
    staticClass: "slider responsive-slick-display-logos"
  }, _vm._l((_vm.corpLogos), function(logo) {
    return _c('div', {
      staticClass: "slide-player"
    }, [_c('a', {
      attrs: {
        "href": logo.linkDestination,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": logo.logoUrl,
        "alt": "CORP LOGO",
        "title": logo.siteNameText
      }
    })])])
  }), 0)])]), _vm._v(" "), (_vm.testimonials) ? _c('div', {
    staticClass: "testimonialscarosal"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v(_vm._s(_vm.testimonialsHeading))]), _vm._v(" "), _c('div', {
    staticClass: "slider responsive-slick-display-testimonials"
  }, _vm._l((_vm.testimonials), function(testimonial) {
    return _c('div', {
      staticClass: "slide-player"
    }, [_vm._v("\n                        “" + _vm._s(testimonial.quote) + "”\n                        "), (testimonial.author) ? _c('div', {
      staticClass: "author"
    }, [_vm._v("--" + _vm._s(testimonial.author) + ", " + _vm._s(testimonial.location) + "--")]) : _vm._e()])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container hubspotHeading"
  }, [_c('h2', [_vm._v(_vm._s(_vm.formHeading))]), _vm._v(" "), (_vm.formLine1) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.formLine1)
    }
  }) : _vm._e()]), _vm._v(" "), _vm._m(5), _vm._v(" "), (_vm.showB2BVideoModal) ? _c('modal', {
    staticClass: "watchVideoModal",
    attrs: {
      "large": "",
      "effect": "fade",
      "value": _vm.showB2BVideoModal
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelModal()
      }
    }
  }, [_c('div', {
    staticClass: "b2bVideoModal",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": require("../assets/watch-video-arrow.png"),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('jwplayer', {
    attrs: {
      "data": _vm.currentVideoPlayer,
      "autoplay": "",
      "controls": ""
    }
  }, [_vm._v("Loading the player...")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-rounded btn-primary btn-lg",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important',
      'outline': 'none'
    }),
    on: {
      "click": function($event) {
        _vm.cancelModal();
        _vm.scrollToFormSection();
      }
    }
  }, [_vm._v("Get Started")]), _c('br')])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-container benefit-panel-bg"
  }, [_c('div', {
    staticClass: "col-sm"
  }, [_c('div', {
    staticClass: "card1 fast"
  }, [_c('h2', {
    staticClass: "auth-title"
  }, [_vm._v("Fast")]), _vm._v(" "), _c('p', {
    staticClass: "auth-text"
  }, [_vm._v("\n                                Our content is easy to digest. Short, microlearning videos have proven\n                                to yield 145% better retention than traditional methods. With 24/7\n                                on-demand on-the-go access, TONE is built for today’s schedules and\n                                shorter attention spans.\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm"
  }, [_c('div', {
    staticClass: "card1 fresh"
  }, [_c('h2', {
    staticClass: "auth-title"
  }, [_vm._v("Fresh")]), _vm._v(" "), _c('p', {
    staticClass: "auth-text"
  }, [_vm._v("\n                                Our content is relevant. And that’s why it works. Unlike canned corporate\n                                training videos, we continuously produce original content that addresses\n                                current topics as they emerge resulting in 82% of employees engaging\n                                once a month, even after a year.\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm"
  }, [_c('div', {
    staticClass: "card1 authentic"
  }, [_c('h2', {
    staticClass: "auth-title"
  }, [_vm._v("Authentic")]), _vm._v(" "), _c('p', {
    staticClass: "auth-text"
  }, [_vm._v("\n                                Our content is real. We’ve cultivated a powerful network of over 150\n                                credentialed experts who tell it like it is. We drive conversations\n                                that candidly explore real-world challenges, share experiences and\n                                insights, and provide practical takeaways.\n                            ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h2', [_vm._v("Real Results")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-row"
  }, [_c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-value"
  }, [_vm._v("96%")]), _vm._v(" "), _c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Want to renew"), _c('br'), _vm._v("after one year")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-value"
  }, [_vm._v("95%")]), _vm._v(" "), _c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Customer"), _c('br'), _vm._v("renewal rate")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-value"
  }, [_vm._v("98%")]), _vm._v(" "), _c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Engagement"), _c('br'), _vm._v("rate")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-value"
  }, [_vm._v("74%")]), _vm._v(" "), _c('div', {
    staticClass: "stat-label"
  }, [_vm._v("World-class Net"), _c('br'), _vm._v("Promoter Score")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "metric-text"
  }, [_vm._v("\n                                ENGAGE ONCE A MONTH"), _c('br'), _vm._v("\n                                EVEN AFTER A YEAR\n                            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "metric-text"
  }, [_vm._v("\n                                MORE LIKELY TO STAY"), _c('br'), _vm._v("\n                                AT THEIR COMPANY\n                            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hubspotForm"
  }, [_c('div', {
    attrs: {
      "id": "hubspotForm"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-14cf791a", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14cf791a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/B2B.vue